import Vue from 'vue';

/**
 * 自定义过滤器
 * */
const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

/**
 * @author  ZwB
 * @desc    活动开始时间结束时间 格式：start_m月start_d日(周start_w)-end_m月end_d日(周end_w)
 * @param   {Object}    item
 * @param   {String}    item.startTime  13 位时间戳
 * @param   {String}    item.endTime    13 位时间戳
 * */
Vue.filter('startEndTimeFormat', function(item){
	var rs = ''
		, start = item.startTime
		, end = item.endTime
		, expr = /^\d{13}$/
		;

	if( expr.test(start) ){
		start = new Date(start);
		rs += (start.getMonth() +1) +'月'+ start.getDate() +'日('+ week[start.getDay()] +')';
	}
	if( expr.test(end) ){
		if( rs !== '' ){
			rs += '-';
		}
		end = new Date(end);
		rs += (end.getMonth() +1) +'月'+ end.getDate() +'日('+ week[end.getDay()] +')';
	}

	return rs;
});

/**
 * @desc    计算折扣，保留一位小数，小于 0.1 取 0.1
 * @param   {Object}    item
 * @param   {Number}    item.price          商品现价
 * @param   {Number}    item.originalPrice  商品原价
 * */
Vue.filter('discount', function(item){ // 计算折扣
	let rs = '';
	if( item && item.price && item.originalPrice && item.price !== item.originalPrice ){
		rs = item.price / item.originalPrice;
		rs *= 10;

		if( rs < 0.1 ){
			rs = 0.1;
		}
		else if( rs > 10 ){
			rs = '';
		}

		if( rs ){
			rs = rs.toFixed(1);

			rs += '折';
		}
	}

	return rs;
});

/**
 * @desc    将价钱分割成整数部分和小数部分，其中小数部分带小数点
 * @param   {String|Number} price
 * */
Vue.filter('splitPriceInt', function(price){
	let rs = '';
	if( price ){
		rs = (''+ price).split('.')[0];
	}

	return rs;
});
Vue.filter('splitPrice', function(price){
	let rs = '';
	if( price ){
		rs = (''+ price).split('.');

		if( rs.length > 1 ){
			rs = '.'+ rs[1];
		}
		else{
			rs = '';
		}
	}

	return rs;
});